

















































































































































































































































































































































import BaseComponent from '@/core/base.component';
import Component from 'vue-class-component';
import { AmenityDto, AmenityListDto } from '@/dto';
import { Pagination } from '@/common';
import {
  AMENITY,
  CONST_AMENITY,
  CONST_SPACE_TYPE,
  SPACE_TYPE,
} from '@/services/shared';

import AmenityService from '@/services/amenity.service';
import BaseCard from '../../_components/BaseCard.vue';
import { FileAttachmentDto } from '@/services/shared/file-upload';
import FileUploadService from '../../../services/shared/file-upload/file-upload.service';
import { UPLOAD_TYPE } from '../../../services/shared/file-upload/file-upload.service';
import { ATTACHMENT_REASON_TYPE } from '@/services/shared/file-upload';
import toast from '../../../../resources/assets/js/services/toast.js';

@Component({
  name: 'AmenityList',
  components: {
    BaseCard,
  },
})
export default class AmenityList extends BaseComponent {
  private amenityCommonList: AmenityDto[] = [];
  private amenityCommonListCount = null;
  private amenityKitchenList: AmenityDto[] = [];
  private amenityKitchenListCount = null;
  private amenitySearchDto = new AmenityListDto();
  private amenityCreateDto = new AmenityDto();
  private amenityCodeSelect: AMENITY[] = [...CONST_AMENITY];
  private paginationCommon = new Pagination();
  private paginationKitchen = new Pagination();
  private amenityUpdateDto = new AmenityDto();

  private selectedAmenity: AmenityDto = new AmenityDto();
  private selectedAmenityId = null;
  private spaceTypeSelect = [1, 2];

  private attachments: FileAttachmentDto[] = [];
  private imageChanged = false;
  private newAttachments: FileAttachmentDto[] = [];
  private newImageChanged = false;

  async upload(file: File) {
    if (file) {
      const attachments = await FileUploadService.upload(UPLOAD_TYPE.AMENITY, [
        file,
      ]);
      this.attachments = [];
      this.attachments.push(
        ...attachments.filter(
          fileUpload =>
            fileUpload.attachmentReasonType === ATTACHMENT_REASON_TYPE.SUCCESS,
        ),
      );
      this.imageChanged = true;
    }
  }

  removeImage() {
    this.attachments = [];
    this.$refs['fileInput'].reset();
    this.imageChanged = false;
  }

  async uploadUpdate(file: File) {
    if (file) {
      const attachments = await FileUploadService.upload(UPLOAD_TYPE.AMENITY, [
        file,
      ]);
      this.newAttachments = [];
      this.newAttachments.push(
        ...attachments.filter(
          fileUpload =>
            fileUpload.attachmentReasonType === ATTACHMENT_REASON_TYPE.SUCCESS,
        ),
      );
      this.newImageChanged = true;
    }
  }

  removeUpdateImage() {
    this.newAttachments = [];
    this.$refs['fileInputUpdate'].reset();
    this.newImageChanged = false;
  }

  search(isPagination?: boolean) {
    if (!isPagination) {
      this.paginationCommon.page = 1;
      this.paginationKitchen.page = 1;
    }
    this.paginationCommon.limit = null;
    this.paginationKitchen.limit = null;

    this.amenitySearchDto.amenityType = AMENITY.COMMON_FACILITY;
    AmenityService.findAll(
      this.amenitySearchDto,
      this.paginationCommon,
    ).subscribe(res => {
      this.amenityCommonList = res.data.items;
      this.amenityCommonListCount = res.data.totalCount;
    });

    this.amenitySearchDto.amenityType = AMENITY.KITCHEN_FACILITY;
    AmenityService.findAll(
      this.amenitySearchDto,
      this.paginationKitchen,
    ).subscribe(res => {
      this.amenityKitchenList = res.data.items;
      this.amenityKitchenListCount = res.data.totalCount;
    });
  }

  paginateCommon() {
    this.search(true);
  }

  paginateKitchen() {
    this.search(true);
  }

  // create amenity
  createAmenity() {
    if (this.attachments.length > 0) {
      this.amenityCreateDto.image = this.attachments;
      AmenityService.create(this.amenityCreateDto).subscribe(res => {
        if (res) {
          toast.success('추가완료');
          this.search();
        }
      });
    } else {
      toast.error('아이콘 이미지를 등록해주세요');
    }
  }

  showCreateModal(amenityType) {
    if (amenityType === 'COMMON_FACILITY') {
      this.amenityCreateDto.amenityType = AMENITY.COMMON_FACILITY;
    }

    if (amenityType === 'KITCHEN_FACILITY') {
      this.amenityCreateDto.amenityType = AMENITY.KITCHEN_FACILITY;
    }
    this.imageChanged = false;
  }

  clearOutCreateDto() {
    this.amenityCreateDto = new AmenityDto();
  }

  // update amentiy
  updateAmenity(amenityNo) {
    amenityNo = this.selectedAmenity.no;
    if (this.newAttachments.length > 0) {
      this.amenityUpdateDto.image = this.newAttachments;
    } else {
      delete this.amenityUpdateDto.image;
    }
    AmenityService.update(amenityNo, this.amenityUpdateDto).subscribe(res => {
      if (res) {
        toast.success('수정완료');
        this.search();
      }
    });
  }

  showUpdateModal(amenityDto) {
    this.amenityUpdateDto = amenityDto;
    this.selectedAmenity = amenityDto;
    this.newImageChanged = false;
  }

  showDeleteModal(amenityId) {
    this.selectedAmenityId = amenityId;
  }

  clearOutUpdateDto() {
    this.amenityUpdateDto = new AmenityDto();
  }

  // delete amentiy
  deleteOne() {
    const id = this.selectedAmenityId;
    AmenityService.deleteOne(id).subscribe(res => {
      if (res) {
        this.search();
        this.$bvModal.hide('delete_amenity');
        toast.success('삭제완료');
      }
    });
  }

  created() {
    this.search();
  }
}
